import { Component, ContentChild, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NextButtonDirective } from '@app/shared/directives/next-button-directive';

@Component({
  selector: 'app-wizard-step-nav-buttons',
  templateUrl: './wizard-step-nav-buttons.component.html',
  styleUrls: ['./wizard-step-nav-buttons.component.scss'],
})
export class WizardStepNavButtonsComponent implements OnInit {
  @Input() hideBack: boolean;
  @Input() hideNext: boolean;
  @Input() showSpinner: boolean = false;

  @Output() backClicked: EventEmitter<void> = new EventEmitter();
  @Output() nextClicked: EventEmitter<void> = new EventEmitter();

  @ContentChild(NextButtonDirective) nextButton;

  constructor() {}

  ngOnInit(): void {}

  public next() {
    this.nextClicked.emit();
  }

  public back() {
    this.backClicked.emit();
  }
}
